import type { FC } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface Props {
  envelopes: {
    red: number | null;
    yellow: number | null;
    green: number | null;
  };
  withTitle?: boolean;
}

const EnvelopesOverview: FC<Props> = ({ envelopes, withTitle = false }) => {
  const { t } = useTranslation(["exercise"]);

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id="tooltip-envelopes-overview" className="text-nowrap">
          Úlohy v obálkách v jahodovém tréninku.
        </Tooltip>
      }
    >
      <div className="envelope-overview-simple">
        {withTitle ? <span>{t("info.envelopesOverview")}</span> : null}
        <div className="envelope-overview-simple__counts">
          <div className="envelope-overview-simple__envelope">
            <div
              className={`envelope-overview-simple__envelope__label envelope-overview-simple__envelope__label--${
                envelopes.green ? "green" : "grey"
              }`}
            >
              {envelopes.green ?? 0}
            </div>
          </div>

          <div className="envelope-overview-simple__envelope">
            <div
              className={`envelope-overview-simple__envelope__label envelope-overview-simple__envelope__label--${
                envelopes.yellow ? "orange" : "grey"
              }`}
            >
              {envelopes.yellow ?? 0}
            </div>
          </div>

          <div className="envelope-overview-simple__envelope">
            <div
              className={`envelope-overview-simple__envelope__label envelope-overview-simple__envelope__label--${
                envelopes.red ? "red" : "grey"
              }`}
            >
              {envelopes.red ?? 0}
            </div>
          </div>
        </div>
      </div>
    </OverlayTrigger>
  );
};

export default EnvelopesOverview;
